import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { useCart } from './cart';

export type Role = 'BUYER' | 'SELLER' | 'ADMIN';

export interface User {
  id: string;
  email: string;
  name: string;
  role: Role;
  verified: boolean;
  emailVerified: boolean;
  walletBalance: number;
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  setSession: (u: User, token: string) => void;
  setAccessToken: (t: string) => void;
  setUser: (u: User) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      setSession: (user, accessToken) => set({ user, accessToken }),
      setAccessToken: (accessToken) => set({ accessToken }),
      setUser: (user) => set({ user }),
      clear: () => { const hadUser = !!get().user; set({ user: null, accessToken: null }); if (hadUser) { try { useCart.getState().clear(); } catch { /* cart store unavailable */ } } },
    }),
    { name: 'souqli-auth', partialize: (s) => ({ user: s.user }) },
  ),
);
